// extracted by mini-css-extract-plugin
export var box = "_60-0";
export var check = "_60-1";
export var checkboxButton = "_60-6";
export var checkboxGroup = "_60-5";
export var disabled = "_60-7";
export var ghost = "_60-9";
export var input = "_60-2";
export var label = "_60-4";
export var normal = "_60-8";
export var uncheck = "_60-3";